module.exports = __webpack_public_path__ + "img/buscar.1fb526fc.svg";